export default {
  data() {
    return {}
  },
  methods: {
    transKeyToLabel(key) {
      switch (key) {
        case 'address1':
          return 'Address1'
        case 'bankruptcyDate':
          return 'Bankruptcy Date'
        case 'bankruptcyType':
          return 'Bankruptcy Type'
        case 'businessId':
          return 'Business Id'
        case 'caseStudyLink':
          return 'Case Study Link'
        case 'cikNumber':
          return 'CIK Number'
        case 'cityName':
          return 'City Name'
        case 'countryName':
          return 'Country Name'
        case 'currentFiscalQuarter':
          return 'Current Fiscal Quarter'
        case 'currentFiscalYear':
          return 'Current Fiscal Year'
        case 'dbtIndex':
          return 'DBT Index'
        case 'dbtIndexDate':
          return 'DBT Index Date'
        case 'emailAddress':
          return 'Email Address'
        case 'employees':
          return 'Employees'
        case 'employeesAsOfDate':
          return 'Employees As Of Date'
        case 'faxNumber':
          return 'FaxNumber'
        case 'federalTaxId':
          return 'FederalTaxId'
        case 'friskScore':
          return 'Frisk Score'
        case 'friskScoreDate':
          return 'Frisk Score Date'
        case 'highRiskLink':
          return 'High Risk Link'
        case 'incorporatedDate':
          return 'Incorporated Date'
        case 'incorporatedIn':
          return 'Incorporated In'
        case 'incorporatedInState':
          return 'Incorporated In State'
        case 'lastBlogLink':
          return 'LastBlogLink'
        case 'latestStatementDate':
          return 'Latest Statement Date'
        case 'marketCap':
          return 'MarketCap'
        case 'naics':
          return 'NAICS'
        case 'name':
          return 'Name'
        case 'parentBusinessId':
          return 'Parent Business Id'
        case 'pastDue':
          return 'Past Due'
        case 'payceScore':
          return 'PAYCE Score'
        case 'payceScoreDate':
          return 'PAYCE Score Date'
        case 'phoneNumber':
          return 'Phone Number'
        case 'postalCode':
          return 'PostalCode'
        case 'publicFilings':
          return 'PublicFilings'
        case 'sic':
          return 'SIC'
        case 'stateProvinceName':
          return 'State Province Name'
        case 'stockExchange':
          return 'Stock Exchange'
        case 'tickerSymbol':
          return 'Ticker Symbol'
        case 'totalDue':
          return 'Total Due'
        case 'tradeAccounts':
          return 'TradeAccounts'
        case 'tradingStatus':
          return 'Trading Status'
        case 'webSite':
          return 'Website'
        case 'zscore':
          return 'Z-Score'
        case 'zscoreDate':
          return 'Z-Score-Date'
        // balance
        case 'accountsPayable':
          return 'Accounts payable'
        case 'accountsReceivable':
          return 'Accounts receivable (trade), net'
        case 'accruedExpenses':
          return 'Accrued expenses'
        case 'accumulatedDepletion':
          return 'Accumulated depletion'
        case 'additionalPaidInCapital':
          return 'Additional paid-in capital'
        case 'balanceAccountingStandard':
          return 'Balance Accounting Standard'
        case 'balanceAuditor':
          return 'Balance Auditor'
        case 'balanceAuditorOpinion':
          return 'Balance Auditor Opinion'
        case 'balanceSheet':
          return 'Balance sheet'
        case 'balanceSource':
          return 'BalanceSource'
        case 'balanceSourceDate':
          return 'Balance Source Date'
        case 'balanceUpdateDate':
          return 'BalanceUpdateDate'
        case 'balanceUpdateType':
          return 'BalanceUpdateType'
        case 'capitalLeaseObligations':
          return 'Capital lease obligations'
        case 'cashDuefromBanks':
          return 'CashDuefromBanks'
        case 'cashandEquivalents':
          return 'CashandEquivalents'
        case 'cashandShortTermInvestments':
          return 'Cash and short term investments'
        case 'cminorityInterest':
          return 'cminorityInterest'
        case 'commonStock':
          return 'Common stock'
        case 'currentPortLtDebtCapitalLeases':
          return 'Current port. LT debt/capital leases'
        case 'deferredIncomeTax':
          return 'Deferred income tax'
        case 'deferredPolicyAcquisitionCosts':
          return 'Deferred policy acquisition costs'
        case 'doubtfulAccounts':
          return 'doubtful accounts'
        case 'esopDebtGuarantee':
          return 'ESOP debt guarantee'
        case 'explorationProduction':
          return 'Exploration & production'
        case 'goodwillNet':
          return 'Goodwill, net'
        case 'insuranceReceivables':
          return 'Insurance receivables'
        case 'intangiblesNet':
          return 'Intangibles, net'
        case 'inventory':
          return 'Total inventory'
        case 'longTermDebt':
          return 'Long term debt'
        case 'longTermInvestments':
          return 'Long term investments'
        case 'netLoans':
          return 'Net loans'
        case 'noteReceivableLongTerm':
          return 'Note receivable - long term'
        case 'notesPayableShortTermDebt':
          return 'Notes payable/short term debt'
        case 'notesReceivableShortTerm':
          return 'Notes receivable - short term'
        case 'otherAssetsTotal':
          return 'Other assets, total'
        case 'otherBearingLiabilitiesTotal':
          return 'Other bearing liabilities, total'
        case 'otherCurrentAssetsTotal':
          return 'Other current assets, total'
        case 'otherCurrentLiabilitiesTotal':
          return 'Other current liabilities, total'
        case 'otherEarningAssetsTotal':
          return 'Other earning assets, total'
        case 'otherEquityTotal':
          return 'Other equity, total'
        case 'otherLiabilitiesTotal':
          return 'Other liabilities, total'
        case 'otherLongTermAssetsTotal':
          return 'Other long term assets, total'
        case 'otherReceivables':
          return 'Other receivables'
        case 'payableAccrued':
          return 'Payable/accrued'
        case 'policyLiabilities':
          return 'Policy liabilities'
        case 'preferredStockNonRedeemableNet':
          return 'Preferred stock (non redeemable), net'
        case 'prepaidExpenses':
          return 'Prepaid expenses'
        case 'propertyPlantEquipment':
          return 'Property/plant/equip., net'
        case 'qminorityInterest':
          return 'qminorityInterest'
        case 'redeemablePreferredStock':
          return 'Redeemable preferred stock'
        case 'retainedEarnings':
          return 'Retained earnings/accum. deficit'
        case 'shortTermInvestments':
          return 'Short Term Investments'
        case 'totalAssets':
          return 'Total assets'
        case 'totalCommonSharesOutstanding':
          return 'Total common shares outstanding'
        case 'totalCurrentAssets':
          return 'Total current assets'
        case 'totalCurrentLiabilities':
          return 'Total current liabilities'
        case 'totalDeposits':
          return 'Total deposits'
        case 'totalEquity':
          return 'Total equity'
        case 'totalLiabilities':
          return 'Total liabilities'
        case 'totalLiabilitiesShareholdersEquity':
          return 'Total liabilities & shareholders equity'
        case 'totalLongTermDebt':
          return 'Total long term debt'
        case 'totalPreferredStockSharesOuts':
          return 'Total preferred stock shares outs.'
        case 'totalReceivables':
          return 'Total receivables, net'
        case 'totalRiskWeightedCapital':
          return 'Total risk weighted capital'
        case 'totalShortTermBorrowings':
          return 'Total short term borrowings'
        case 'totalUtilityPlant':
          return 'TotalUtilityPlant'
        case 'treasuryStockCommon':
          return 'Treasury stock - common'
        case 'unrealizedGainLoss':
          return 'Unrealized gain/loss'
        case 'utilityPlant':
          return 'Utility plant'
        case 'utilityPlantAccumulatedDepreciation':
          return 'Utility plant accumulated depreciation'
        // income
        case 'allowanceForFundsUsedDuringConst':
          return 'Allowance For Funds Used During Const'
        case 'amortOfPolicyAcquisitionCosts':
          return 'AmortOfPolicyAcquisitionCosts'
        case 'basicPrimaryEpsInclExtraItems':
          return 'Basic/primary EPS incl. extra. items'
        case 'costOfGoods':
          return 'Cost of revenue, total'
        case 'depreciationAmortization':
          return 'DepreciationAmortization'
        case 'depreciationAmortizationSupplemental':
          return 'Depreciation/amortization, supplemental'
        case 'dilutedEpsInclExtraItems':
          return 'Diluted EPS incl. extra. items'
        case 'discontinuedOperations':
          return 'DiscontinuedOperations'
        case 'equityInAffiliates':
          return 'EquityInAffiliates'
        case 'extraordinaryItem':
          return 'ExtraordinaryItem'
        case 'fuelExpense':
          return 'FuelExpense'
        case 'fundsFromOperationsReit':
          return 'FundsFromOperationsREIT'
        case 'gainLossOnSaleOfAssets':
          return 'GainLossOnSaleOfAssets'
        case 'iminorityInterest':
          return 'iminorityInterest'
        case 'incomeAccountingStandard':
          return 'IncomeAccountingStandard'
        case 'incomeAfterTax':
          return 'Income after tax'
        case 'incomeAuditor':
          return 'IncomeAuditor'
        case 'incomeAuditorOpinion':
          return 'IncomeAuditorOpinion'
        case 'incomeBeforeTax':
          return 'Income before tax'
        case 'incomePeriodLength':
          return 'IncomePeriodLength'
        case 'incomePeriodUnits':
          return 'IncomePeriodUnits'
        case 'incomeSource':
          return 'IncomeSource'
        case 'incomeSourceDate':
          return 'IncomeSourceDate'
        case 'incomeTaxTotal':
          return 'Income tax - total'
        case 'incomeUpdateDate':
          return 'IncomeUpdateDate'
        case 'incomeUpdateType':
          return 'IncomeUpdateType'
        case 'interestCapitalizedSupplemental':
          return 'Interest capitalized, supplemental'
        case 'interestExpenseIncomeNetNonOperating':
          return 'InterestExpenseIncomeNetNonOperating'
        case 'interestExpenseIncomeNetOperating':
          return 'InterestExpenseIncomeNetOperating'
        case 'interestExpenseNetNonOperating':
          return 'Interest expense/income, net non-operating'
        case 'interestExpenseNetOperating':
          return 'InterestExpenseNetOperating'
        case 'interestExpenseSupplemental':
          return 'Interest expense, supplemental'
        case 'interestIncomeBank':
          return 'InterestIncomeBank'
        case 'interestInvestmentIncomeNonOperating':
          return 'Interest/investment income, non-operating'
        case 'interestInvestmentIncomeOperating':
          return 'InterestInvestmentIncomeOperating'
        case 'itotalInterestExpense':
          return 'itotalInterestExpense'
        case 'loanLossProvision':
          return 'LoanLossProvision'
        case 'lossesBenefitsAndAdjustmentsTotal':
          return 'LossesBenefitsAndAdjustmentsTotal'
        case 'netIncome':
          return 'Net income'
        case 'netInterestIncome':
          return 'NetInterestIncome'
        case 'netInterestIncomeAfterLoanLossProvision':
          return 'NetInterestIncomeAfterLoanLossProvision'
        case 'netInvestmentIncome':
          return 'Net investment income'
        case 'nonInterestExpenseBank':
          return 'NonInterestExpenseBank'
        case 'nonInterestIncomeBank':
          return 'NonInterestIncomeBank'
        case 'operatingIncome':
          return 'Operating income'
        case 'operationsMaintenance':
          return 'OperationsMaintenance'
        case 'otherNet':
          return 'Other, net'
        case 'otherOperatingExpensesTotal':
          return 'OtherOperatingExpensesTotal'
        case 'otherRevenueTotal':
          return 'OtherRevenueTotal'
        case 'realizedGainsLosses':
          return 'RealizedGainsLosses'
        case 'researchAndDevelopment':
          return 'ResearchAndDevelopment'
        case 'revenue':
          return 'Revenue'
        case 'sga':
          return 'SG&A expenses, total'
        case 'taxOnExtraordinaryItems':
          return 'TaxOnExtraordinaryItems'
        case 'totalExpenses':
          return 'TotalExpenses'
        case 'totalExtraordinaryItems':
          return 'Total extraordinary items'
        case 'totalOperatingExpense':
          return 'Total expense'
        case 'totalPremiumsEarned':
          return 'Total premiums earned'
        case 'totalSales':
          return 'Total revenue'
        case 'unusualIncomeExpense':
          return 'Unusual income/expense'
        case 'usgaapAdjustment':
          return 'USGAAPAdjustment'
        // cash
        case 'cnetIncome':
          return 'Cash Flow Net Income'
        case 'depreciationDepletion':
          return 'Depreciation/depletion'
        case 'nonCashItems':
          return 'Non-cash Items'
        case 'changesInWorkingCapital':
          return 'Changes in working capital'
        case 'netCashOperating':
          return 'Total cash from operating activities'
        case 'capitalExpenditures':
          return 'Capital Expenditures'
        case 'otherInvestingCashFlowItemsTotal':
          return 'Other investing cash flow items, total'
        case 'totalCashFromInvestingActivities':
          return 'Total cash from investing activities'
        case 'financingCashFlowItems':
          return 'Financing cash flow items'
        case 'totalCashDividendsPaid':
          return 'TotalCashDividendsPaid'
        case 'issuanceRetirementOfStockNet':
          return 'Issuance/retirement of stock, net'
        case 'issuanceRetirementOfDebtNet':
          return 'Issuance/retirement of debt, net'
        case 'totalCashFromFinancingActivities':
          return 'Total cash from financing activities'
        case 'foreignExchangeEffects':
          return 'Foreign exchange effects'
        case 'netChangeInCash':
          return 'Net change in cash'
        case 'netCashBeginningBalance':
          return 'Net cash-beginning balance'
        case 'netCashEndingBalance':
          return 'Net cash-ending balance'
        case 'cashInterestPaid':
          return 'Cash interest paid'
        case 'cashTaxesPaid':
          return 'Cash taxes paid'
        case 'grossMargin':
          return 'Gross Margin'
        case 'sgaOfSales':
          return 'SG&A margin'
        case 'operatingMarginOfSales':
          return 'Operating margin'
        case 'ebitdaMarginOfSales':
          return 'EBITDA margin'
        case 'pretaxIncomeOfSales':
          return 'Pre-tax income margin'
        case 'netProfitMarginOfSales':
          return 'Net Profit margin'
        case 'incomeTaxOfPretaxIncome':
          return 'Effective tax rate'
        case 'depreciationOfCapEx':
          return 'Depreciation % of Capex'
        case 'depreciationOfPpe':
          return 'Depreciation % of PP&E'
        case 'capitalExpenseOfPpe':
          return 'Capital expenditures % of PP&E'
        case 'capExOfWorkingCap':
          return 'Capital expenditures % of Working Capital'
        case 'timesInterestEarned':
          return 'Interest coverage ratio'
        case 'freeCashFlow':
          return 'TTMFreeCashFlow'
        // liquid
        case 'currentAssetsOfDebt':
          return 'Current assets % of short-term debt'
        case 'workingCapital':
          return 'Working capital '
        case 'workingCapitalOfSales':
          return 'Working capital % of sales'
        case 'cashOfDebt':
          return 'Cash % of short-term debt'
        case 'cashRatio':
          return 'Cash ratio'
        case 'quickAssets':
          return 'Quick assets'
        case 'quickAssetsOfDebt':
          return 'Quick assets % of short-term debt'
        case 'quickRatio':
          return 'Quick ratio'
        case 'currentRatio':
          return 'Current ratio'
        case 'arOfSales':
          return 'Accounts receivable % of sales'
        case 'arTurnover':
          return 'Accounts receivable turnover (annualized)'
        case 'daysSalesOutstanding':
          return 'Days sales outstanding'
        case 'inventoryFinanced':
          return '% inventory financed by vendors'
        case 'inventoryTurnover':
          return 'Inventory turnover (annualized)'
        case 'daysSalesInventory':
          return 'No. of days sales in inventory'
        case 'inventoryWorkingCapital':
          return 'Inventory Working Capital'
        case 'apTurnover':
          return 'Accounts payable turnover (annualized)'
        case 'debtAssetsRatio':
          return 'Total debt to assets ratio'
        case 'debtEquityRatio':
          return 'Total debt to equity ratio'
        case 'debtTangibleNetWorthRatio':
          return 'Total debt to tangible net worth'
        case 'liabilitiesEquityRatio':
          return 'Total liabilities to equity ratio'
        case 'liabilitiesNetWorthRatio':
          return 'Total liabilities to tangible net worth ratio'
        case 'netTangibleAssets':
          return 'Net tangible assets'
        case 'shortTermDebt':
          return 'Short-term debt'
        case 'shortTermDebtOfDebt':
          return 'Short-term debt % of total debt'
        case 'shortTermDebtOfWorkingCapital':
          return 'Short-term debt % of working capital'
        case 'tangibleNetWorth':
          return 'Tangible net worth'
        case 'tierOneCapitalPercent':
          return 'Tier One Capital Percent'
        case 'totalCapitalPercent':
          return 'TotalCapitalPercent'
        case 'totalDebt':
          return 'Total debt'
        case 'capitalLeases1':
        case 'longTermDebt1':
          return 'Maturing within 1 year'
        case 'capitalLeases2':
        case 'longTermDebt2':
          return 'Maturing within 2 year'
        case 'capitalLeases3':
        case 'longTermDebt3':
          return 'Maturing within 3 year'
        case 'capitalLeases4':
        case 'longTermDebt4':
          return 'Maturing within 4 year'
        case 'capitalLeases5':
        case 'longTermDebt5':
          return 'Maturing within 5 year'
        case 'longTermDebtRemaining':
          return 'Remaining Long Term Debt'
        case 'totalLongTermDebtSupp':
          return 'Total Long Term Debt'
        case 'totalCapitalLeases':
          return 'Total Capital Leases'
        case 'operatingLeases1':
          return 'Maturing within 1 year'
        case 'operatingLeases2':
          return 'Maturing within 2 year'
        case 'operatingLeases3':
          return 'Maturing within 3 year'
        case 'operatingLeases4':
          return 'Maturing within 4 year'
        case 'operatingLeases5':
          return 'Maturing within 5 year'
        case 'operatingLeasesRemaining':
          return 'Remaining Operating Leases'
        case 'totalOperatingLeases':
          return 'Total Operating Leases'
        case 'cumulativeObligations3':
          return 'Total Obligations Maturing within 3 years'
        case 'returnOnEquity':
          return 'Return on equity %'
        case 'returnOnAssets':
          return 'Return on total assets %'
        case 'returnOnNetAssets':
          return 'Return on net tangible equity %'
        case 'returnOnTangibleNetworth':
          return 'Return on net tangible assets %'
        case 'ttmDividends':
          return 'TTMDividends'
      }
    },
  },
}
